import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { useAuth } from "@/context/AuthContext";
import { hasSeenTour, startTour } from "@/lib/productTour";

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;
    if (hasSeenTour(user.id)) return;
    // Wait until the sidebar has painted so anchors are attachable.
    const id = setTimeout(() => {
      if (document.querySelector('[data-testid="sidebar"]')) {
        startTour({ userId: user.id, isAdmin: user.role === "superadmin" });
      }
    }, 900);
    return () => clearTimeout(id);
  }, [user?.id, user?.role]);

  return (
    <div className="min-h-screen bg-[#f6f7f9]">
      <TopBar onToggleSidebar={() => setMobileOpen((v) => !v)} />
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <main className="md:ml-56 pt-12 min-h-screen" data-testid="dashboard-main">
        <div className="px-4 md:px-8 py-6 md:py-8 fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
